import defaultThumbnail from '../../assets/thumbnails/default_thumb.svg';
import giaThumbnail from '../../assets/thumbnails/gia_thumb.svg';
import igiThumbnail from '../../assets/thumbnails/igi_thumb.svg';
import threeSixtyThumbnail from '../../assets/thumbnails/360_thumb.svg';
import defaultThumbnailBlue from '../../assets/thumbnails/default_thumb_blue.svg';
import giaThumbnailBlue from '../../assets/thumbnails/gia_thumb_blue.svg';
import igiThumbnailBlue from '../../assets/thumbnails/igi_thumb_blue.svg';
import threeSixtyThumbnailBlue from '../../assets/thumbnails/360_thumb_blue.svg';

declare interface IThumbnails {
  [key: string]: string;
}

export const getThumbnail = (str?: string, isNewPage?: boolean) => {
  if (!str || str === '') {
    return isNewPage ? defaultThumbnailBlue : defaultThumbnail;
  }

  const thumbnail: IThumbnails = {
    default: isNewPage ? defaultThumbnailBlue : defaultThumbnail,
    gia: isNewPage ? giaThumbnailBlue : giaThumbnail,
    igi: isNewPage ? igiThumbnailBlue : igiThumbnail,
    360: isNewPage ? threeSixtyThumbnailBlue : threeSixtyThumbnail,
  };

  if (!thumbnail[str.toLowerCase()]) {
    return thumbnail.default;
  } else {
    return thumbnail[str.toLowerCase()];
  }
};

export const getThumbnailNew = (str?: string): string => {
  if (!str || str === '') {
    return defaultThumbnailBlue;
  }

  const thumbnail: IThumbnails = {
    default: defaultThumbnailBlue,
    gia: giaThumbnailBlue,
    igi: igiThumbnailBlue,
    360: threeSixtyThumbnailBlue,
  };

  if (!thumbnail[str.toLowerCase()]) {
    return thumbnail.default;
  } else {
    return thumbnail[str.toLowerCase()];
  }
};
